import Cookies from 'js-cookie';
import { CART_COOKIE, COOKIE_DOMAIN } from 'Utils/constants';
import { CustomError, fetchWithJWT } from "Utils/helpers";


/**
 * Cookie name for setting/getting user's cart id
 **/ 
const getCartCookie = () => {
  const cartId = Cookies.get(CART_COOKIE);

  if(!cartId || cartId === 'undefined') {
    return null;
  }

  return cartId;
}

const setCartCookie = (value) => {
  const domain = process.env.NODE_ENV !== 'production' ? '' : COOKIE_DOMAIN;

  return Cookies.set(CART_COOKIE, value, {domain: domain, expires: 30});
}


/**
 * API route for getting carts items based on cartID stored in cookie
 * */
const getCartItems = (cartId) => {
	return fetchWithJWT(`${ewiSettings.root}/wp-json/MasterTheme/v1/GetCartItems/${cartId}`);
}


/**
 * Calls WP API route that internally calls store api "UpdateCartItemAsync"
 * Returns response of success containing cart data for item updated
 * Will generate new cart id if no cart id is passed!
 * */
const addCartItemAsync = async (offerId, paramsString) => {
  if(!offerId) {
    return console.error('Offer Id is required to update cart items!');
  }

  const cartGuid = getCartCookie();

  const response = await fetchWithJWT(`${ewiSettings.root}/wp-json/MasterTheme/v1/AddCartItem`, {
    method: 'POST',
    body: JSON.stringify({
      "cartGuid": cartGuid ? cartGuid : null,
      "offerId": offerId,
      "queryString": paramsString,
    }),
  });

  if(response?.ok) {
    const cart = await response.json();

    if(!cartGuid) {
      setCartCookie(cart.CartGuid);
    }
    return cart;
  } else {
    const error = await response.json();
    throw new CustomError('cart_error', `${error.code} - ${error.message}.`);
  }
}


/**
 * Calls WP API route that internally calls store api "UpdateCartItemAsync"
 * Returns response of success containing cart data after item is removed
 * */
const removeCartItem = (offerId, cartItemGuid) => {
  const cartGuid = getCartCookie();

  if(!cartGuid || !cartItemGuid) {
    throw new CustomError('cart_error', 'Missing cart guid or item guid. Removal of item cancelled.');
  }

  return fetchWithJWT(`${ewiSettings.root}/wp-json/MasterTheme/v1/RemoveCartItem/${cartGuid}/${offerId}/${cartItemGuid}`, {
    method: 'POST'
  });
}


/**
 * Calls WP API route that internally calls store api "GetOffersAsync".
 * Returns json array of offers based on offerOriginIds passed into it
 * */
const getOffersAsync = async (offerIds) => {
  let response;

  try {
    response = await fetchWithJWT(`${ewiSettings.root}/wp-json/MasterTheme/v1/GetOffersAsync/${offerIds}`);
  } catch (error) {
    throw new CustomError('cart_error', `${error.code} - ${error.message}.`);
  }

  if(response?.ok) {
    return await response.json();
  } else {
    const error = await response.json();
    throw new CustomError('cart_error', `${error.code} - ${error.message}.`);
  }
}

const isOfferValid = (startDate, endDate) => {
  // Get today's date without time
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set the time to 00:00:00

  // Parse the input dates
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Check if today's date is within the date range
  return today >= start && today <= end;
}

export { addCartItemAsync, removeCartItem, getCartCookie, getCartItems, getOffersAsync, isOfferValid };